export const WEBSOCKETS_MESSAGE_TYPE = {
    ERROR:      -1,  
    PING:       11,
    PONG:       12,
    GPIO_ORDER: 300,
};

// Error codes the hub sends in the login frame (action -1). The apikey one
// mirrors BleOrder.ERROR_API_KEY_INVALID in django-sentio.
export const WEBSOCKETS_ERROR_CODE = {
    APIKEY_INVALID: 4030,
};

export const WEBSOCKETS_CONFIGURATION = {
    TIMEOUT_PING:   120000,
    KEEP_ALIVE:     120,
};
